<!--
 * @Author: your name
 * @Date: 2021-03-30 22:10:31
 * @LastEditTime: 2023-03-12 22:26:16
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\App.vue
-->
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { pcPath, mPath  } from "@/config/serverPath";

export default {
    name: "App",
    created() {
        // 跳转移动端页面
        var device = navigator.userAgent.toLowerCase();
        if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(device)) {
            // window.location = window.location.href.replace(pcPath, mPath);
			window.location = mPath;
        }

        // 将头部的信息保存在store里面
        this.$store.dispatch("BasicInfo/fetchBasicInfo");
    },
};
</script>

<style lang="scss">
#app {
    font: 12px/1.5 tahoma, arial, Hiragino Sans GB, WenQuanYi Micro Hei,
        \5fae\8f6f\96c5\9ed1, \5b8b\4f53, sans-serif;
}
</style>
